const currentYear = new Date().getFullYear();
const allEquateYearsData = [];

for (let year = currentYear; year >= 2003; year--) {
    allEquateYearsData.push({
        label: year.toString(),
        value: year.toString()
    });
}

allEquateYearsData.push({
    label: "Before 2003",
    value: "2002"
});

export const equateYears = [
    {
        type: "Dropdown",
        id: "equate-year",
        content: [
            {
                label: "Year",
                value: "",
                disabled: true
            },
           ...allEquateYearsData
        ]
    }
]